
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Busonrentinkharadi() {



    const cardData =
    {
        keyword: 'Bus On Rent in Kharadi Pune',
        heading: 'Amruta Travels: Bus On Rent in Kharadi Pune',
        headingDescription: 'Amruta Travels offers Bus on Rent in Kharadi Pune, providing reliable and comfortable transportation solutions for various occasions. Whether you are organizing a corporate event, school trip, family function, or group tour, our well-maintained buses ensure a smooth and enjoyable journey. Choose from our range of buses, including 17-seater, 32-seater, and 50-seater options, to suit your group size. With experienced drivers, punctual service, affordable pricing, and 24/7 availability, Amruta Travels makes your travel in and around Kharadi simple and stress-free. Book your bus with Amruta Travels and experience a journey of comfort and convenience!',


        top: 'Top Places to Visit in Pune with Amruta Travels',
"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas of the Maratha Empire, Shaniwar Wada is a historic fort in central Pune. Known for its massive Delhi Gate, beautiful gardens, and tales of royal intrigue, it's a major attraction. Don't miss the evening light and sound show that narrates its rich past."
  },
  {
    "title": "Aga Khan Palace",
    "description": "An architectural gem and a symbol of India’s freedom struggle, the Aga Khan Palace was built in 1892. It once housed Mahatma Gandhi and his wife Kasturba. Today, it features a museum with personal artifacts, peaceful gardens, and memorials."
  },
  {
    "title": "Sinhagad Fort",
    "description": "This hilltop fort, located 35 km from Pune, is famous for its historic Battle of Sinhagad and stunning views. A popular trekking destination, it offers visitors a mix of adventure, history, and local Maharashtrian snacks like pithla-bhakri."
  },
  {
    "title": "Osho Ashram",
    "description": "Nestled in the lush greenery of Koregaon Park, Osho International Meditation Resort is a spiritual retreat offering meditation, wellness workshops, and mindfulness programs. It attracts global visitors looking for peace and transformation."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Dating back to the 8th century, this rock-cut temple dedicated to Lord Shiva is carved from a single basalt rock. Located in the heart of Pune, it’s a peaceful oasis amidst the city bustle with detailed stone carvings and spiritual ambiance."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "This one-of-a-kind museum showcases over 20,000 artifacts including musical instruments, weapons, sculptures, and art pieces. It’s a window into India’s rich cultural history, curated lovingly by Dr. Dinkar Kelkar in memory of his son."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "A popular weekend spot just outside Pune, Khadakwasla Dam is perfect for a scenic drive, evening stroll, or picnic. The serene waters, cool breeze, and roadside food vendors make it a relaxing escape from the city."
  },
  {
    "title": "Fergusson College Road",
    "description": "A youthful and energetic area filled with cafes, eateries, and shopping outlets, Fergusson College Road is a go-to spot for college students and tourists alike. From fashion finds to tasty street food, it offers a lively Pune experience."
  },
  {
    "title": "Lal Mahal",
    "description": "Originally built in the 1630s by Shahaji Bhosale, Lal Mahal is linked to the childhood of Chhatrapati Shivaji Maharaj. The reconstructed palace features exhibits and murals depicting the Maratha warrior’s early life and battles."
  },
  {
    "title": "Pune-Okayama Friendship Garden",
    "description": "Inspired by Japan’s Korakuen Garden, this beautifully landscaped park features flowing streams, stone bridges, koi ponds, and walking paths. It's a serene and photogenic spot ideal for families and couples."
  }
],



     "services": [
    {
      "name": "Urbania Bus on Rent in Kharadi",
      "description": "Rent a luxury Urbania bus in Kharadi with Amruta Travels. Perfect for corporate events, large group outings, or special occasions, the Urbania bus provides a premium travel experience with comfortable seating and modern amenities."
    },
    {
      "name": "17 Seater Bus on Rent per Km in Kharadi",
      "description": "Amruta Travels offers 17-seater buses on rent in Kharadi, with flexible pricing per kilometer. Ideal for small group trips, corporate outings, or family gatherings, our buses ensure a comfortable and affordable journey."
    },
    {
      "name": "Tempo Traveller on Rent in Kharadi",
      "description": "Hire a Tempo Traveller in Kharadi for group outings, family trips, or corporate events. Our vehicles come with air conditioning, ample space, and experienced drivers to ensure a safe and enjoyable journey."
    },
    {
      "name": "Bus on Rent in Wagholi Pune for Outstation",
      "description": "Planning an outstation trip? Amruta Travels offers reliable bus rentals from Wagholi, Pune for your group travel needs. Choose from a variety of buses to suit your group size, ensuring a comfortable and punctual journey."
    },
    {
      "name": "Bus Hire in Wagholi for Picnic",
      "description": "Organizing a picnic from Wagholi? Amruta Travels provides bus hire services for family picnics, school trips, or corporate outings. Our buses are spacious, comfortable, and perfect for a fun day out with friends and family."
    },
    {
      "name": "Wedding Bus on Rental in Wagholi",
      "description": "Rent a bus for your wedding in Wagholi with Amruta Travels. Our buses can accommodate large groups, ensuring that your guests travel in comfort to the wedding venue. Punctual and reliable service for your big day."
    },
    {
      "name": "Bus On Rent for Wedding in Wagholi",
      "description": "Amruta Travels offers bus rental services for weddings in Wagholi. With various bus sizes and AC options available, we ensure that your guests are comfortable and arrive on time for the wedding ceremony."
    },
    {
      "name": "Urbania Bus on Rent in Wagholi",
      "description": "For a luxurious travel experience, rent an Urbania bus in Wagholi with Amruta Travels. Our premium buses are perfect for corporate events, large group outings, and special occasions with top-tier amenities."
    },
    {
      "name": "Force Urbania on Rent in Kharadi",
      "description": "Hire the Force Urbania bus in Kharadi for a premium, comfortable travel experience. Ideal for corporate events, VIP transportation, and special gatherings, the Force Urbania ensures a smooth, luxurious ride."
    },
    {
      "name": "Bus Hire in Kharadi IT Park",
      "description": "Amruta Travels provides reliable bus hire services in Kharadi IT Park for corporate trips, team outings, and employee transportation. Our fleet includes buses of all sizes, ensuring that your staff travels comfortably to and from work or events."
    },
    {
      "name": "14 17 20 25 Seater Bus on Rent in Kharadi",
      "description": "Rent a 14, 17, 20, or 25-seater bus in Kharadi for your group trips, corporate events, or family outings. Amruta Travels offers comfortable and affordable buses for small to medium-sized groups with experienced drivers."
    },
    {
      "name": "32 35 40 45 50 Seater Bus on Rent in Kharadi",
      "description": "For large groups, rent a 32, 35, 40, 45, or 50-seater bus in Kharadi with Amruta Travels. Our buses are perfect for family reunions, group tours, corporate outings, or any other large event, with spacious seating and AC options."
    },
    {
      "name": "Bus Hire in Kharadi for Corporate Outing",
      "description": "Amruta Travels provides bus hire services in Kharadi for corporate outings, team-building exercises, and employee transport. Our fleet includes comfortable, spacious buses with AC, ensuring your staff arrives at their destination in style."
    },
    {
      "name": "Top Bus On Rent Monthly Basis in Kharadi Pune",
      "description": "Amruta Travels offers monthly bus rental services in Kharadi Pune for corporate transportation, employee shuttles, and educational institutions. Our buses are available on a monthly basis for reliable, cost-effective travel solutions."
    },
    {
      "name": "Monthly Bus Rentals in Kharadi, Pune",
      "description": "Rent a bus on a monthly basis in Kharadi, Pune with Amruta Travels. Our monthly bus rental service is ideal for regular transport needs, whether for corporate, educational, or industrial purposes. Enjoy consistent, punctual service at competitive rates."
    }
  ],
  "tableData": [
    ["Urbania Bus on Rent in Kharadi", "17 Seater Bus on Rent per Km in Kharadi"],
    ["Tempo Traveller on Rent in Kharadi", "Bus on Rent in Wagholi Pune for Outstation"],
    ["Bus Hire in Wagholi for Picnic", "Wedding Bus on Rental in Wagholi"],
    ["Bus On Rent for Wedding in Wagholi", "Urbania Bus on Rent in Wagholi"],
    ["Force Urbania on Rent in Kharadi", "Bus Hire in Kharadi IT Park"],
    ["14 17 20 25 Seater Bus on Rent in Kharadi", "32 35 40 45 50 Seater Bus on Rent in Kharadi"],
    ["Bus Hire in Kharadi for Corporate Outing", "Top Bus On Rent Monthly Basis in Kharadi Pune"],
    ["Monthly Bus Rentals in Kharadi, Pune", ""]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Trusted Bus Rental Service in Kharadi, Pune",
    "WhyChoosedescription": "Amruta Travels offers reliable and efficient Bus On Rent in Kharadi, Pune—perfect for corporate trips, weddings, airport transfers, school outings, and outstation tours. Whether you need a one-time booking or regular transport support, we provide well-maintained buses with professional service tailored to your travel needs."
  },
  {
    "WhyChooseheading": "Fleet Options for All Group Sizes",
    "WhyChoosedescription": "Choose from our wide range of buses including 17, 20, 32, 35, 40, 45, and 50-seater vehicles. Whether it’s a small group or a large team, we ensure spacious, clean, and air-conditioned (or non-AC) buses with ample luggage space and comfortable seating for a smooth journey."
  },
  {
    "WhyChooseheading": "Perfect for Corporate, Wedding, and Family Events",
    "WhyChoosedescription": "Kharadi being a major IT and residential hub, our bus rental services are widely used for employee transport, family events, marriage functions, and day trips. We understand the need for timely, organized travel and offer buses with flexible schedules to match your event timeline."
  },
  {
    "WhyChooseheading": "Professional Drivers with Route Expertise",
    "WhyChoosedescription": "Our experienced and courteous drivers are familiar with Kharadi’s roads and Pune’s key routes. Whether you're heading to Magarpatta, Hinjewadi, or outstation locations like Lonavala, Mahabaleshwar, Shirdi, or Mumbai, our drivers ensure safe and punctual service with a customer-friendly attitude."
  },
  {
    "WhyChooseheading": "Affordable Rates with No Hidden Charges",
    "WhyChoosedescription": "We offer transparent and competitive pricing for bus rentals in Kharadi. With no hidden fees, our quotes include all essential costs so you can manage your budget confidently. Whether you need a few hours or a full-day rental, we tailor packages to your exact requirements."
  },
  {
    "WhyChooseheading": "Clean and Well-Maintained Buses",
    "WhyChoosedescription": "All our buses undergo regular maintenance and deep cleaning to ensure a hygienic and comfortable experience. With push-back seats, clean interiors, and smooth suspension, our buses are ideal for long and short-distance travel alike—offering reliability and comfort throughout."
  },
  {
    "WhyChooseheading": "Flexible Pickup & Drop-Off Locations in and Around Kharadi",
    "WhyChoosedescription": "We offer flexible pickup and drop-off options throughout Kharadi and nearby areas such as EON IT Park, Mundhwa, Viman Nagar, Hadapsar, and Wagholi. You tell us the location—we’ll be there on time, ensuring a seamless start and end to your journey."
  },
  {
    "WhyChooseheading": "Simple Booking Process and Dedicated Support",
    "WhyChoosedescription": "Booking a bus with Amruta Travels is quick and hassle-free. Use our website, call our customer service, or visit our office. Our dedicated support team helps with route planning, bus selection, and real-time assistance—ensuring a smooth experience from booking to drop-off."
  }
]






















    }

const faqData = [
  {
    question: 'How can I rent a bus in Kharadi, Pune?',
    answer: 'Booking a bus in Kharadi is easy with Amruta Travels. You can contact us via phone, book online, or visit our office. We’ll assist you in choosing the right bus based on your group size and travel needs.',
  },
  {
    question: 'What types of buses are available for rent in Kharadi?',
    answer: 'We offer a fleet of 32, 35, 40, 45, and 50-seater buses in AC, non-AC, and luxury variants. Our buses are ideal for local travel, corporate use, weddings, school trips, and outstation journeys.',
  },
  {
    question: 'Do you provide buses for local travel within Kharadi and Pune?',
    answer: 'Yes, our buses are available for local travel in and around Kharadi, including city tours, events, shuttle services, and employee transportation.',
  },
  {
    question: 'Can I hire a bus from Kharadi for outstation travel?',
    answer: 'Absolutely. We provide outstation bus rentals from Kharadi to destinations like Mumbai, Goa, Shirdi, Mahabaleshwar, and more with experienced drivers and well-maintained buses.',
  },
  {
    question: 'Are your buses comfortable and well-maintained?',
    answer: 'Yes, all our buses are regularly serviced, sanitized, and equipped with comfortable seating, air conditioning (for AC variants), and ample luggage space.',
  },
  {
    question: 'How much does it cost to rent a bus in Kharadi?',
    answer: 'The cost depends on the bus type, distance, trip duration, and other factors. Contact us with your travel details for a transparent and personalized quote.',
  },
  {
    question: 'Do you offer corporate transportation in Kharadi?',
    answer: 'Yes, we provide reliable and punctual bus services for IT companies, BPOs, and offices in Kharadi, including daily staff transport and corporate events.',
  },
  {
    question: 'Can I request multiple pickup and drop points in and around Kharadi?',
    answer: 'Yes, we offer flexible routing options. Share your group’s pickup and drop locations and we’ll plan the most efficient route.',
  },
  {
    question: 'Why choose Amruta Travels for bus rental in Kharadi?',
    answer: 'Amruta Travels is known for professional service, clean and comfortable buses, trained drivers, and a customer-focused approach. We make travel stress-free and enjoyable.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Saurabh Deshmukh',
    role: 'Team Lead, IT Company in Kharadi',
    text: 'We hired a 45-seater bus from Amruta Travels for a corporate team outing. The bus was punctual, clean, and the ride was smooth. Great experience overall!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Pooja Jadhav',
    role: 'Wedding Planner, Pune',
    text: 'For a wedding event in Kharadi, we booked a 35-seater luxury bus. Amruta Travels provided excellent service, and our guests were very happy. Highly recommended!',
    rating: 5,
  },
];

























































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];




const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bus on Rent in Kharadi Pune",
  "image": "https://bushireinpune.com/assets/images/bus-on-rent-in-kharadi.jpg",
  "description": "Bus hire in Kharadi and Wagholi Pune for weddings, corporate outings, picnics, and monthly staff transportation. Options include Urbania, Tempo Travellers, and AC/Non-AC buses from 14 to 50 seaters. Affordable per km pricing for one-time or monthly rentals near Kharadi IT Park.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "6845"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3599",
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/bus-on-rent-in-kharadi"
  }
};






    return (
        <div>

<Helmet>
  <title>Call: +91 7353109555 | Bus on Rent in Kharadi Pune | Wedding, Corporate & Monthly | Amruta Travels</title>
  <meta 
    name="description" 
    content="Hire buses in Kharadi & Wagholi for weddings, picnics, corporate outings & monthly travel. Choose from 14 to 50 seater buses, Tempo Travellers & Urbania. Book affordable AC/Non-AC bus rentals in Pune." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/44.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Busonrentinkharadi;